import { Container } from 'react-bootstrap';

const Orders = () => {
    return (
        <Container fluid>
            <h1>Orders page</h1>
            <div className="w-100 p-0 m-0 mt-3"><div style={{ position: 'relative', overflow: 'hidden'}}><a href="https://yandex.kz/maps/162/almaty/?utm_medium=mapframe&utm_source=maps" style={{ color: '#eee', position: 'absolute', top: '0px'}}>Алматы</a><a href="https://yandex.kz/maps/162/almaty/?ll=76.831091%2C43.348340&utm_medium=mapframe&utm_source=maps&z=17" style={{color: '#eee', position: 'absolute', top: '14px'}}>Алматы — Яндекс Карты</a><iframe src="https://yandex.kz/map-widget/v1/?ll=76.831091%2C43.348340&z=17" width="100%" height="400" frameborder="1" allowfullscreen="true" style={{position: 'relative'}}></iframe></div></div>
        </Container>
    );
};

export default Orders;